import React from "react"
import ListPageContainer from "../../Common/jsx/ListPageContainer"
import { getEntitiesUrlParameters } from "../../Common/js/get_entities_url_parameters"
import withHooks from "../../Common/jsx/WithHooks"
import { strToSnakeCase, strToUpperSnakeCase } from "../../Common/js/string_utils"
import { getQuestionTypes, patchQuestionType } from "../../api/api_question_type"
import { FR, GB } from "country-flag-icons/react/3x2"

class QuestionTypesList extends React.Component {
  constructor(props) {
    super(props)

    this.dMgr = this.props.DebugManager(this.constructor.name)
    // this.dMgr.activate(true)
    this.dMgr.debug("const_props:", this.props)
    this.state = {
      isReadyToRender: false,
      listPagination: {
        itemsPerPage: 50,
        page: 1,
        totalItems: -1,
        firstPageUrl: "",
        lastPageUrl: "",
        previousPageUrl: "",
        nextPageUrl: "",
      },
      listOrders: {
        id: "asc",
      },
      listFilters: {
        isVisible: true,
        searchStrings: "",
      },
    }
    this.dMgr.debug("init_state:", this.state)

    this.getEntities = this.getEntities.bind(this)
    this.setEntityIsVisible = this.setEntityIsVisible.bind(this)
    this.getHeaders = this.getHeaders.bind(this)
    this.getFilters = this.getFilters.bind(this)
    this.getRows = this.getRows.bind(this)
    this.buildEntity = this.buildEntity.bind(this)
    this.listPaginationUpdate = this.listPaginationUpdate.bind(this)
    this.listOrdersUpdate = this.listOrdersUpdate.bind(this)
    this.listFiltersUpdate = this.listFiltersUpdate.bind(this)
  }

  componentDidMount() {
    this.getEntities()
  }

  async getEntities() {
    let parameters = getEntitiesUrlParameters(this.state.listPagination, this.state.listFilters, this.state.listOrders)

    // CONFIG ------------------------------------------------------------------------------------------------
    let entities = await getQuestionTypes(parameters)
    // / CONFIG ----------------------------------------------------------------------------------------------

    let listPagination = {
      ...this.state.listPagination,
      ...{
        totalItems: entities["hydra:totalItems"],
        pageTypeUrl: entities["hydra:view"]["@id"],
        firstPageUrl: entities["hydra:view"]["hydra:first"],
        lastPageUrl: entities["hydra:view"]["hydra:last"],
        previousPageUrl: entities["hydra:view"]["hydra:previous"],
        nextPageUrl: entities["hydra:view"]["hydra:next"],
      },
    }

    this.setState({ isReadyToRender: true, listPagination, entities: entities["hydra:member"] })
  }

  async setEntityIsVisible(entity, isVisible, doneCallback) {
    await patchQuestionType(entity.id, { isVisible: isVisible })

    this.getEntities()
    this.props.notif.success()
    if (doneCallback !== undefined) {
      doneCallback()
    }
  }

  // CONFIG ------------------------------------------------------------------------------------------------

  getHeaders() {
    return [
      {
        name: "id",
        title: this.props.t("form.id"),
        className: "text-center",
        sort: this.state.listOrders.id !== undefined ? this.state.listOrders.id : "",
      },

      {
        name: "shortname",
        title: this.props.t("form.shortname"),
        sort: this.state.listOrders.shortname !== undefined ? this.state.listOrders.shortname : "",
      },

      {
        name: "nameFr",
        title: [this.props.t("form.name"), <FR key="thFR" className="lang_flag margin-left-5" />],
        sort: this.state.listOrders.nameFr !== undefined ? this.state.listOrders.nameFr : "",
      },
      // {
      //   name: "descriptionFr",
      //   title: [this.props.t("form.description"), <FR key="thFR" className="lang_flag margin-left-5" />],
      //   sort: this.state.listOrders.descriptionFr !== undefined ? this.state.listOrders.descriptionFr : "",
      // },
      {
        name: "commonStatementFr",
        title: [this.props.t("form.commonStatement"), <FR key="thFR" className="lang_flag margin-left-5" />],
        sort: this.state.listOrders.commonStatementFr !== undefined ? this.state.listOrders.commonStatementFr : "",
      },
      {
        name: "nameEn",
        title: [this.props.t("form.name"), <GB key="thGB" className="lang_flag margin-left-5" />],
        sort: this.state.listOrders.nameEn !== undefined ? this.state.listOrders.nameEn : "",
      },
      // {
      //   name: "descriptionEn",
      //   title: [this.props.t("form.description"), <GB key="thGB" className="lang_flag margin-left-5" />],
      //   sort: this.state.listOrders.descriptionEn !== undefined ? this.state.listOrders.descriptionEn : "",
      // },
      {
        name: "commonStatementEn",
        title: [this.props.t("form.commonStatement"), <GB key="thGB" className="lang_flag margin-left-5" />],
        sort: this.state.listOrders.commonStatementEn !== undefined ? this.state.listOrders.commonStatementEn : "",
      },
      {
        name: "actions",
        title: this.props.t("app.actions"),
      },
    ]
  }

  getFilters() {
    return [
      {
        name: "searchStrings",
        type: "text",
        label: this.props.t("app.search"),
        value: this.state.listFilters.searchStrings,
      },

      {
        name: "isVisible",
        type: "checkbox",
        label: this.props.t("app.hideDeleted"),
        checked: this.state.listFilters.isVisible,
      },
    ]
  }

  buildEntity(entity) {
    entity.customFields = []

    return entity
  }

  getRows() {
    return this.state.entities.map((entity) => {
      entity = this.buildEntity(entity)

      let actions = []
      if (this.props.RightsManager.userHasRight(strToUpperSnakeCase(this.props.entityType) + ":EDIT")) {
        actions = actions.concat(["edit", "delete", "restore"])
      }

      return {
        entity: entity,
        fields: [
          {
            name: "id",
            value: entity.id,
            className: "text-center",
          },
          {
            name: "shortname",
            value: entity.shortname,
          },
          {
            name: "nameFr",
            value: entity.nameFr,
          },
          // {
          //   name: "descriptionFr",
          //   value: entity.descriptionFr,
          // },
          {
            name: "commonStatementFr",
            value: entity.commonStatementFr,
          },
          {
            name: "nameEn",
            value: entity.nameEn,
          },
          // {
          //   name: "descriptionEn",
          //   value: entity.descriptionEn,
          // },
          {
            name: "commonStatementEn",
            value: entity.commonStatementEn,
          },
          {
            name: "actions",
            actions: actions,
          },
        ],
      }
    })
  }
  // /CONFIG ------------------------------------------------------------------------------------------------

  listPaginationUpdate(parameters) {
    this.dMgr.debug("listPaginationUpdate parameters:", parameters)
    this.setState({ listPagination: { ...this.state.listPagination, ...parameters } }, this.getEntities)
  }

  listOrdersUpdate(order) {
    this.dMgr.debug("listOrdersUpdate order:", order)

    let listOrders = {}
    if (this.state.listOrders[order] !== undefined) {
      if (this.state.listOrders[order] === "asc") {
        listOrders[order] = "desc"
      } else {
        listOrders[order] = "asc"
      }
    } else {
      listOrders[order] = "asc"
    }
    this.setState({ listOrders: listOrders }, this.getEntities)
  }

  listFiltersUpdate(filters) {
    this.dMgr.debug("listFiltersUpdate filters:", filters)
    this.setState({ listFilters: { ...this.state.listFilters, ...filters } }, this.getEntities)
  }

  render() {
    if (!this.state.isReadyToRender) {
      this.dMgr.debug("render:", "not ready")
      return null
    }
    this.dMgr.rendering()

    let toRender = (
      <ListPageContainer
        tableName={"list_" + this.props.entitiesType}
        referrerUrl={"/admin/" + strToSnakeCase(this.props.entitiesType)}
        entityType={this.props.entityType}
        entitiesType={this.props.entitiesType}
        tableHeaders={this.getHeaders()}
        tableRows={this.getRows()}
        filters={this.getFilters()}
        listPagination={this.state.listPagination}
        listPaginationUpdate={this.listPaginationUpdate}
        listOrdersUpdate={this.listOrdersUpdate}
        listFilters={this.state.listFilters}
        listFiltersUpdate={this.listFiltersUpdate}
        deleteEntity={(entity, doneCallback) => this.setEntityIsVisible(entity, false, doneCallback)}
        restoreEntity={(entity) => this.setEntityIsVisible(entity, true)}
      />
    )

    this.dMgr.renderDone()
    return toRender
  }
}

export default withHooks(QuestionTypesList)
